import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import memberServices from "../services/MemberService";
import directusServices from "../services/DirectusService";
import _ from 'lodash';
import { BOARD_CODE, LIMIT_TOP_NUMBER, STATUS } from '../components/LeaderboardComponent/Template/types';


export const registerParticipantByCampaignId = createAsyncThunk(
  'Leaderboard/registerParticipantByCampaignId',
  async (campaignId) => {
    const response = await memberServices.registerParticipantByCampaignId(campaignId);
    return response.data;
  }
)

export const fetchBoardsByCampaignId = createAsyncThunk(
  'Leaderboard/fetchBoardsByCampaignId',
  async (campaignId) => {
    const response = await memberServices.getBoardsByCampaignId(campaignId);
    return response.data;
  }
)

export const fetchScoresByCampaignId = createAsyncThunk(
  'Leaderboard/fetchScoresByCampaignId',
  async (campaignId) => {
    const response = await memberServices.getScoresByCampaignId(campaignId);
    return response.data;
  }
)

export const fetchParticipantByCampaignId = createAsyncThunk(
  'Leaderboard/fetchParticipantByCampaignId',
  async (campaignId) => {
    const response = await memberServices.getParticipantByCampaignId(campaignId);
    return response.data;
  }
)

export const fetchTranslations = createAsyncThunk(
  'Leaderboard/fetchTranslations',
  async () => {
    const respone = await directusServices.getTranslations('member_campaign');
    return respone.data
  }
)

const LeaderboardSlice = createSlice({
  name: 'Leaderboard',
  initialState: {
    participant: {},
    mainBoards: [],
    extraBoards: [],
    translations: {},
    scores: [],
    prize: "leaderboard.banner.price",
    worldcupUrl: "",
    isLoading: false
  },
  reducers: {
    resetParticipant: (state, action) => {
      state.participant = {...action.payload}
    },
    resetSlice: (state) => {
      state.participant = {};
      state.mainBoards = [];
      state.extraBoards = [];
      state.translations = {};
      state.scores = [];
    }
  },
  extraReducers: (builder) => {
    builder.addCase(registerParticipantByCampaignId.fulfilled, (state, action) => {
      state.participant = action.payload;
    });
    builder.addCase(fetchBoardsByCampaignId.fulfilled, (state, action) => {
      const { boards } = action.payload;
      if (boards && boards.length > 0) {
        state.mainBoards.push(...[...boards].slice(0, 1));
        state.extraBoards.push(...[...boards].slice(1, boards.length));
      }
    });
    builder.addCase(fetchTranslations.fulfilled, (state, action) => {
      state.translations = action.payload.data
        .reduce((map, obj) => {
          map[obj.locale_code] = obj;
          return map;
        },
          {});

    });
    builder.addCase(fetchParticipantByCampaignId.fulfilled, (state, action) => {
      state.participant = action.payload;
    });
    builder.addCase(fetchScoresByCampaignId.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchScoresByCampaignId.fulfilled, (state, action) => {
      state.scores = forceRankBoard(action.payload);
      state.isLoading = false;
    });

  }
})

export const {
  resetParticipant,
  resetSlice
 } = LeaderboardSlice.actions;

export default LeaderboardSlice.reducer;

const createRankList = (listPar = [], curPar = {}, topNumber = 0, curParOutTopIndex = 0) => {
  if (_.isEmpty(listPar)) {
    return listPar;
  }
  topNumber = topNumber > listPar.length ? listPar.length : topNumber;
  curParOutTopIndex = curParOutTopIndex > topNumber ? topNumber : curParOutTopIndex;

  const result = [...listPar.slice(0, topNumber)];

  if (_.isEmpty(curPar)) {
    return result;
  }

  const isUserOutTop = curPar.rank > result[result.length - 1].rank;

  if (isUserOutTop) {
    result.splice(curParOutTopIndex, 0, curPar);
  }

  return result;
};

const forceRankBoard = (scores = []) => {
  if (_.isEmpty(scores)) {
    return scores
  }
  const boardStatus = scores[0] ? scores[0].boardStatus : null;
  return scores.map((score) => {
  const { boardCode, participants, currentParticipant, runnersUp } = score;
  const isEsportBoard = ![BOARD_CODE.SILVER_STAKES_SOCCER, BOARD_CODE.SILVER_STAKES_BASKETBALL].some((code) => code === boardCode);
  if (boardStatus === STATUS.END && isEsportBoard) {
    switch (boardCode) {
      case BOARD_CODE.SILVER_STAKES_ESPORTS: {
        score.runnersUp = createRankList(runnersUp, currentParticipant, LIMIT_TOP_NUMBER.EPSPORT_TOTAL_END, LIMIT_TOP_NUMBER.EPSPORT_TOTAL_END);
        break;
      }
      case BOARD_CODE.SILVER_STAKES_ESPORTS_R1:
      case BOARD_CODE.SILVER_STAKES_ESPORTS_R2:
      case BOARD_CODE.SILVER_STAKES_ESPORTS_R3:
      case BOARD_CODE.SILVER_STAKES_ESPORTS_R4: {
        score.participants = createRankList(participants, currentParticipant, LIMIT_TOP_NUMBER.EPSPORT_ROUND_END, 0);
        break;
      }
      default : {
        break;
      }
    }
    return score;
  }

  const currentPlayer = participants.findIndex((player) =>
    JSON.stringify(player) === JSON.stringify(currentParticipant));
  if (currentPlayer !== 0 && currentParticipant) {
    score.participants.unshift(currentParticipant);
  }

  return score;
  })
}


// WEBPACK FOOTER //
// ./src/app/slices/LeaderboardSlice.js